"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentType;
(function (ComponentType) {
    ComponentType[ComponentType["PivotTable"] = 1] = "PivotTable";
    ComponentType[ComponentType["Table"] = 2] = "Table";
    ComponentType[ComponentType["Map"] = 3] = "Map";
    ComponentType[ComponentType["Chart"] = 4] = "Chart";
    ComponentType[ComponentType["Custom"] = 2048] = "Custom";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
//# sourceMappingURL=ComponentType.js.map